var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIsleOfMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8506C24.8366 32.8506 32 25.6871 32 16.8506C32 8.01403 24.8366 0.850586 16 0.850586C7.16344 0.850586 0 8.01403 0 16.8506C0 25.6871 7.16344 32.8506 16 32.8506Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9242 11.5765L20.7933 15.6121L17.4002 14.9856L15.216 10.4834L9.31561 12.5772L8.8503 11.266L7.30655 11.0758L8.46974 14.3538L12.5303 13.3154L13.6842 16.5672L10.8772 20.7098L15.6408 24.7727L14.7379 25.8313L15.345 27.2634L17.6024 24.6169L14.6728 21.6196L16.912 18.9944L21.9031 19.354L23.0399 13.1971L24.4081 13.4498L25.3449 12.208L21.9242 11.5765Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIsleOfMan);
export default __webpack_public_path__ + "static/media/flag_isle_of_man.fc57baf7b4d30e319cb8fd37e8959e72.svg";
export { ForwardRef as ReactComponent };